<template>
    <div class="pub-wrap-select">
        <div class="mask" v-show="showModal" @click="showModal=false"></div>
        <div class="pub-info-select" @click="showModal=!showModal">
            <span>{{selectItem[selectKey]}}</span>
            <img src="../assets/images/1-6_03.png" alt="">
        </div>
        <ul class="pub-select-list" v-show="showModal">
            <li v-for="(item,index) in list" :key="index+1" 
            :style="width" :class="{'on':selectItem[selectKey]==item[selectKey]}"
            @click="checkItem(item)">{{item[selectKey]}}
            </li>
        </ul>
    </div>
</template>
<style>
.pub-wrap-select {
    width: 100%;
    position: relative;
}

.pub-info-select {
    width: 100%;
    height: 0.45rem;
    line-height: 0.45rem;
    border: 1px solid #b8b8b8;
    border-radius: 1px;
    box-sizing: border-box;
}
.pub-wrap-select.custom-01 .pub-info-select{
    height: 0.5rem;
    line-height: 0.5rem;
}

.pub-info-select img {
    float: right;
    height: 100%;
    width:auto;
    border-left: 1px solid #b8b8b8;
}

.pub-select-list {
    position: absolute;
    left: 0;
    top: 100%;
    padding: 2px;
    border: 1px solid #dbdbdb;
    z-index: 1000;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    background-color: white;
}

.pub-select-list li {
    height: 0.4rem;
    line-height: 0.4rem;
    text-align: center;
    color: #535154;
    border-top: 1px solid #b9b8b8;
    padding: 0 0.2rem;
}

.pub-select-list li.on {
    color: white;
    background-color: #0a8593;
}

.pub-select-list li:first-child {
    border-top: 0;

}
</style>
<script>
    export default {
        name: "selectList",
        data: function () {
            return {
                showModal: false,
                selectItem: this.selected || {}
            }
        },
        props: ["list", "selected", 'selectKey','widthLi', 'dove'],
        methods: {
            checkItem: function (item) {
                this.selectItem = item;
                this.showModal = false;
                var ret = JSON.parse(JSON.stringify(item));
                if (this.dove !== undefined) {
                  ret.dove = this.dove;
                }
                this.$emit("checkedItem", ret);
            }
        },
        watch: {
            'list': function (n, o) {
                if(!this.selectItem[this.selectKey]){
                    this.selectItem=n[0];
                    var ret = JSON.parse(JSON.stringify(n[0]));
                    if (this.dove !== undefined) {
                        ret.dove = this.dove;
                    }
                    this.$emit("checkedItem", ret);
                }
            },
            selected(){
                this.selectItem = this.selected || {};
            },
        },
        computed:{
            width:function (n) {
                return 'width:'+this.widthLi||''
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/shared/components/selectList.vue